import React from "react";
import { withStyles, makeStyles } from "@material-ui/core";
import { Table } from "@material-ui/core";
import { TableCell } from "@material-ui/core";
import { TableHead } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import { Paper } from "@material-ui/core";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    // minWidth: 800,
  },
}));

export default function SummaryTable(props) {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <StyledTableCell>Program</StyledTableCell>
            <StyledTableCell>Program Count</StyledTableCell>
          </TableRow>
        </TableHead>
        {props.tableData &&
          props.tableData.map((row, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>{row.program}</StyledTableCell>
              <StyledTableCell>{row.program_count}</StyledTableCell>
            </StyledTableRow>
          ))}
      </Table>
    </Paper>
  );
}
